import { Pipe, PipeTransform } from "@angular/core";
import { formatDistanceToNow } from "date-fns";

@Pipe({
  name: "timeAgo",
  pure: false,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return "N/A";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "Invalid date";

    return formatDistanceToNow(date, { addSuffix: true });
  }
}
